import { SecurityBadge } from "@circle-react/components/shared/Paywalls/components/SecurityBadge";
import { Link } from "@circleco/compass/components/Link";

import { t } from "@/i18n-js/instance";

import { isExistingMember } from "../helpers";
import type { EmailVerificationStatus } from "../types";

const LOCALE_ROOT = "paywall_checkout.form.email_verification_states.otp_state";

interface FooterSectionProps {
  isResending?: boolean;
  isSubmitting?: boolean;
  onShowPasswordForm: () => void;
  status: EmailVerificationStatus | null;
}

export const FooterSection = ({
  status,
  isSubmitting = false,
  isResending = false,
  onShowPasswordForm,
}: FooterSectionProps) => (
  <div className="flex items-center justify-between">
    {isExistingMember(status) && (
      <Link
        asButton
        variant="custom"
        typography="label-sm"
        hoverDecoration="underline"
        onClick={onShowPasswordForm}
        disabled={isSubmitting || isResending}
      >
        {t([LOCALE_ROOT, "sign_in_with_password"])}
      </Link>
    )}

    <SecurityBadge />
  </div>
);
